import { render, staticRenderFns } from "./WithExcerptSmall.vue?vue&type=template&id=55269bc6&"
import script from "./WithExcerptSmall.vue?vue&type=script&lang=ts&"
export * from "./WithExcerptSmall.vue?vue&type=script&lang=ts&"
import style0 from "./WithExcerptSmall.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports